import { useEffect } from 'react'

import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { theme } from '@maestro/local/theme'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export function useLoginModal() {
  const { getHashParamValue, removeHashParam } = useHash()
  const { session } = useMaestroSession()

  const { modalKey: loginModalKey } = theme().loginPage

  useEffect(() => {
    const hasLoginHash = getHashParamValue(loginModalKey) !== undefined
    const isUserLoggedIn = !!session?.user?.id

    if (hasLoginHash && isUserLoggedIn) {
      removeHashParam(loginModalKey)
    }
  }, [getHashParamValue, loginModalKey, removeHashParam, session?.user?.id])

  return {
    loginModalKey,
  }
}
